/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_TermsInputs */

const en_auth_legal_terms = /** @type {(inputs: Auth_Legal_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const pl_auth_legal_terms = /** @type {(inputs: Auth_Legal_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Auth_Legal_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_legal_terms = /** @type {((inputs?: Auth_Legal_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_legal_terms(inputs)
	return en_auth_legal_terms(inputs)
});